import { render, staticRenderFns } from "./PriceListGroup.vue?vue&type=template&id=0b01cdfe"
import script from "./PriceListGroup.vue?vue&type=script&lang=js"
export * from "./PriceListGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports